import { useMemo } from 'react';

export const useFormat = ({
  maximumFractionDigits,
  minimumFractionDigits = 0,
  type,
  empty,
  currency,
  signDisplay,
  notation = 'standard',
  compactDisplay = 'long',
}: any) => {
  const formatter = useMemo(() => {
    return Intl.NumberFormat('en-US', {
      maximumFractionDigits: maximumFractionDigits,
      minimumFractionDigits: minimumFractionDigits,
      style: type,
      currency,
      signDisplay: signDisplay,
      notation,
      compactDisplay,
    });
  }, [currency, type, maximumFractionDigits]);

  return (value: any) => {
    if (Array.isArray(value)) {
      return value.map(v => {
        if (!Number.isFinite(v)) {
          return empty;
        }
        return formatter.format(v);
      });
    }

    if (!Number.isFinite(value)) {
      return empty;
    }
    return formatter.format(value);
  };
};
